import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69db7775a749570014080cb1/jarvissovereign/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69db7775a749570014080cb1/jarvissovereign/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69db7775a749570014080cb1/jarvissovereign/src/styles/tailwind.css");
